export interface RapportiniOffline {
  id: string
  wo_id: number
  timestamp: number
  payload: {
    descrizione_lavori: string
    note: string
    nome_cliente: string
    materiali_json: string
    checklist_json: string
    firma_tecnico: string
    apparati_json: string
    num_ap?: string
    [key: string]: string | undefined
  }
  foto: {
    [key: string]: ArrayBuffer | null
  }
  firma_cliente: ArrayBuffer | null
  firma_tecnico_file: ArrayBuffer | null
}

const DB_NAME = 'xsophia-offline'
const STORE_NAME = 'rapportini-pending'

let dbInstance: IDBDatabase | null = null

async function getDB(): Promise<IDBDatabase> {
  if (dbInstance) return dbInstance

  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1)

    req.onerror = () => reject(req.error)
    req.onsuccess = () => {
      dbInstance = req.result
      resolve(dbInstance)
    }

    req.onupgradeneeded = (e) => {
      const db = (e.target as IDBOpenDBRequest).result
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'id' })
      }
    }
  })
}

export async function saveRapportiniOffline(rapportini: RapportiniOffline): Promise<string> {
  const db = await getDB()
  return new Promise((resolve, reject) => {
    const tx = db.transaction([STORE_NAME], 'readwrite')
    const store = tx.objectStore(STORE_NAME)
    const req = store.add(rapportini)

    req.onsuccess = () => resolve(rapportini.id)
    req.onerror = () => reject(req.error)
  })
}

export async function getPendingRapportini(): Promise<RapportiniOffline[]> {
  const db = await getDB()
  return new Promise((resolve, reject) => {
    const tx = db.transaction([STORE_NAME], 'readonly')
    const store = tx.objectStore(STORE_NAME)
    const req = store.getAll()

    req.onsuccess = () => resolve((req.result || []) as RapportiniOffline[])
    req.onerror = () => reject(req.error)
  })
}

export async function deleteRapportiniOffline(id: string): Promise<void> {
  const db = await getDB()
  return new Promise((resolve, reject) => {
    const tx = db.transaction([STORE_NAME], 'readwrite')
    const store = tx.objectStore(STORE_NAME)
    const req = store.delete(id)

    req.onsuccess = () => resolve()
    req.onerror = () => reject(req.error)
  })
}

export async function clearAllRapportini(): Promise<void> {
  const db = await getDB()
  return new Promise((resolve, reject) => {
    const tx = db.transaction([STORE_NAME], 'readwrite')
    const store = tx.objectStore(STORE_NAME)
    const req = store.clear()

    req.onsuccess = () => resolve()
    req.onerror = () => reject(req.error)
  })
}

export async function blobToArrayBuffer(blob: Blob | null): Promise<ArrayBuffer | null> {
  if (!blob) return null
  return blob.arrayBuffer()
}

export function arrayBufferToBlob(ab: ArrayBuffer | null, type: string = 'application/octet-stream'): Blob | null {
  if (!ab) return null
  return new Blob([ab], { type })
}
